export const APPLE_PROVIDER_ID = 'apple.com';